'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var noop = function noop() {};

exports.default = function (instance, _ref) {
  var _ref$before = _ref.before;
  var before = _ref$before === undefined ? noop : _ref$before;
  var _ref$after = _ref.after;
  var after = _ref$after === undefined ? noop : _ref$after;

  Object.keys(instance).forEach(function (methodName) {
    if (typeof instance[methodName] === 'function') {
      (function () {
        var originalMethod = instance[methodName];

        instance[methodName] = function () {
          before(methodName, arguments);
          var returnVal = originalMethod.apply(this, arguments);
          after(methodName, arguments);

          return returnVal;
        };
      })();
    }
  });

  return instance;
};

module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/instrument-methods/dist/index.js
 ** module id = 369
 ** module chunks = 0
 **/